import React from 'react';
import { RiDeleteBin7Fill } from 'react-icons/ri';

import { useRecoilValue } from 'recoil';
import { userTokenState } from 'recoils/user/userState';

import ButtonGroup from 'components/button/ButtonGroup';
import ErrorLayout from 'components/error/ErrorLayout';

import usePageNavigate from 'hooks/common/usePageNavigate';
import useHeader from 'hooks/menu/useHeader';

/**
 * 삭제된 항목에 대한 에러 페이지를 표시하는 컴포넌트
 * @param {string} code - 에러 코드
 * @param {React.ReactNode} children - 삽입할 추가 콘텐츠
 */
const DeleteErrorContent = ({ code, children }) => {
  const userToken = useRecoilValue(userTokenState);
  const { onNavClick } = usePageNavigate();
  const { onLoginBtnClick } = useHeader();

  const config = errorConfigs[code] || errorConfigs['default'];
  const extra = config.extraButtons(onNavClick, onLoginBtnClick, userToken);

  return (
    <>
      {children}
      <ErrorLayout
        icon={config.icon ?? <RiDeleteBin7Fill />}
        title={config.title}
        desc={config.desc}
        button={
          <ButtonGroup button={[...getCommonButtons(onNavClick), ...extra]} />
        }
      />
    </>
  );
};

export default DeleteErrorContent;
// 공통 버튼 정의
const getCommonButtons = (onNavClick) => [
  {
    text: '메인으로',
    variant: 'dark-outline',
    size: 'big',
    onClick: () => onNavClick('/'),
    gtm: {
      url: '/',
      id: 'delete-error-modal-main-btn',
    },
  },
];

// 에러 설정 객체
const errorConfigs = {
  '0003': {
    title: (
      <>
        해당 공지사항은 삭제되었거나 <br />더 이상 존재하지 않습니다.
      </>
    ),
    desc: ['최신 공지사항을 확인해주세요.'],
    extraButtons: (onNavClick) => [
      {
        text: '확인하기',
        variant: 'primary',
        size: 'big',
        onClick: () => onNavClick('/notice'),
        gtm: {
          url: '/notice',
          id: 'delete-error-modal-notice-btn',
        },
      },
    ],
  },
  3000: {
    title: (
      <>
        해당 APP은 삭제되었거나 <br />더 이상 존재하지 않습니다.
      </>
    ),
    desc: ['APP 리스트를 확인해주세요.'],
    extraButtons: (onNavClick) => [
      {
        text: 'APP으로',
        variant: 'primary',
        size: 'big',
        onClick: () => onNavClick('/app'),
        gtm: {
          url: '/app',
          id: 'delete-error-modal-app-btn',
        },
      },
    ],
  },
  1000: {
    title: (
      <>
        작성하신 개발문의는 삭제되었거나 <br />더 이상 존재하지 않습니다.
      </>
    ),
    desc: ['새로운 게시글을 통해 질문해 주세요.'],
    extraButtons: (onNavClick, onLoginBtnClick, userToken) => [
      {
        text: '작성하기',
        variant: 'primary',
        size: 'big',
        onClick: () =>
          !userToken ? onLoginBtnClick() : onNavClick('/community-write'),
        gtm: {
          url: !userToken ? '/login' : '/community-write',
          id: `delete-error-modal-community-write-btn`,
        },
      },
    ],
  },
  default: {
    title: (
      <>
        해당 게시물은 삭제되었거나 <br />더 이상 존재하지 않습니다.
      </>
    ),
    desc: [''],
    extraButtons: () => [],
    gtm: {
      url: '',
      id: `delete-error-modal-btn`,
    },
  },
};
